import axios from 'axios';
import type { DateTime } from 'luxon';

export default class SlidersService
{
    public static path = 'admin/cms/sliders';

    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(this.path, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`${this.path}/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post<Resource<FormModel>>(this.path, model)).data;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put<Resource<FormModel>>(`${this.path}/${id}`, model)).data;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`${this.path}/${id}`)).data as Statement;
    }

    public static async getAutocompleteList(search: string, limit: number = 10)
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/autocomplete`, {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    public static async fetchAutocompleteModel(id: number)
    {
        return (await axios.get<ListItemModel>(`${this.path}/autocomplete/${id}`)).data;
    }
}

export interface FilterModel
{
    name: string;
}

export interface ListItemModel
{
    id: number;
    name: string;
    authorId: number;
    authorName: string;
    dateModifiedUtc: DateTime;
}

export interface FormModel
{
    id: number;
    name: string;
    datePublishedUtc: DateTime;
    dateDismissedUtc: DateTime;
    websiteId: number;
    locale: string;
    numberOfSlides: number;
    timeForSlide: number;
    slides: any;
}
